<template>
  <div class="blog-detail-container">
    <!-- 左侧内容区域 -->
    <div class="blog-content" ref="content">
      <h1>{{ blog.title }}</h1>
      
      <div v-for="section in sections" :key="section.id" :id="'section-'+section.id">
        <h2 >{{ section.title }}</h2>
        <div v-html="section.content"></div>
      </div>
    </div>
    
    <!-- 右侧导航区域 -->
    <div class="blog-navigation">
      <div class="navigation-line"></div>
      <div 
        v-for="section in sections" 
        :key="section.id"
        class="nav-item"
        :class="{ active: activeSection === section.id }"
        @click="scrollToSection(section.id)"
      >
        <div class="nav-indicator"></div>
        <span>{{ section.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['id'],
  data() {
    return {
      blog: {
        title: 'Vue2 高级技巧指南',
        // 其他博客信息...
      },
      paragraph: `<p style="font-size: 24px;">（分段正文）在香港的數碼通訊生態中，WhatsApp已成為不可或缺的核心平台。它不僅是最受歡迎的即時通訊工具，更已深深融入香港人的日常生活和社交習慣。對於商戶而言，WhatsApp也代表著一個直接、高效且具有巨大潛力的客戶互動渠道，以建立更緊密、更個性化的客戶關係。</p>

<p style="font-size: 24px;">KConnect為商戶提供一站式營運管理平台，結合WATI專業WhatsApp Business API服務，為商戶打造全面的客戶互動解決方案。服務涵蓋自動回覆、群發訊息、客戶分群等功能，使商戶能輕鬆管理大量客戶對話，提供24/7自動化客戶支援。系統還能根據客戶行為發送個性化營銷訊息，展示完整產品目錄，並通過KPay的支付功能，讓客戶直接在WhatsApp對話中完成交易。</p>

<p style="font-size: 24px;">例如，透過WhatsApp Business API結合KPay收款連結功能，商戶可以設置自動聊天機器人回答客戶問題、提供產品目錄，並在客戶決定購買時直接發送支付連結完成交易。這種整合不僅提高了便利性，還能創造更流暢的購物體驗，從諮詢到購買實現無縫轉換，大大縮短了轉化時間。通過WhatsApp，商戶還可以發送訂單確認、發貨通知，甚至提供個性化的產品推薦，從而增強客戶忠誠度。</p>`,
      sections: [
        { id: 1, title: '组件通信', content: '...详细内容...' },
        { id: 2, title: '状态管理', content: '...详细内容...' },
        { id: 3, title: '性能优化', content: '...详细内容...' },
        { id: 4, title: '路由管理', content: '...详细内容...' }
      ],
      activeSection: 1,
      observer: null
    }
  },
  mounted() {
    for (let section of this.sections) {
      section.content = this.paragraph
    }
    // 在滚动事件中调用
    window.addEventListener('scroll', this.checkActiveSection)
    this.setupIntersectionObserver()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      }
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const sectionId = entry.target.id.replace('section-', '')
            console.log('observe sectionId:', sectionId)
            // this.activeSection = parseInt(sectionId)
          }
        })
      }, options)
      
      // 观察所有章节元素
      this.sections.forEach(section => {
        const element = document.getElementById(`section-${section.id}`)
        if (element) {
          this.observer.observe(element)
        }
      })
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(`section-${sectionId}`)
      this.activeSection = parseInt(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    scrollToSection2(sectionId) {
      const element = document.getElementById(`section-${sectionId}`)
      if (element) {
        const offset = 20 // 调整这个值
        const bodyRect = document.body.getBoundingClientRect().top
        const elementRect = element.getBoundingClientRect().top
        const elementPosition = elementRect - bodyRect
        const offsetPosition = elementPosition - offset
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    },
    checkActiveSection() {
      const triggerPos = window.innerHeight * 0.5 // 视口中线
      
      this.sections.forEach(section => {
        const element = document.getElementById(`section-${section.id}`)
        if (element) {
          const rect = element.getBoundingClientRect()
          // 元素顶部在视口中线以上，且底部在视口中线以下
          if (rect.top <= triggerPos && rect.bottom > triggerPos) {
            this.activeSection = section.id
          }
        }
      })
    },

  }
}
</script>

<style scoped>
.blog-detail-container {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.blog-content {
  flex: 1;
  padding-right: 40px;
}

.blog-navigation {
  width: 250px;
  position: sticky;
  top: 20px;
  align-self: flex-start;
  padding-left: 20px;
}

.navigation-line {
  position: absolute;
  /*left: 7px;*/
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #e0e0e0;
}

.nav-item {
  position: relative;
  padding: 8px 0 8px 20px;
  cursor: pointer;
  color: #666;
  transition: all 0.3s;
}

.nav-item:hover {
  color: #333;
}

.nav-indicator {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: transparent;
  transition: all 0.3s;
}

.nav-item.active {
  color: #42b983;
  font-weight: bold;
}

.nav-item.active .nav-indicator {
  background-color: #42b983;
  height: 24px;
}

h2 {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.paragraph {
  font-size: 24px;
  font-weight: 400;
}

@media (max-width: 768px) {
  .blog-detail-container {
    flex-direction: column;
  }
  .blog-navigation {
    width: 100%;
    position: static;
    margin-top: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/BlogDetail2.vue